
import { Component, Output, Input, EventEmitter, ViewChildren, QueryList } from '@angular/core';
import { ServiceService } from "../../../../injections/service.service";
import {PredictiveComponent} from "../../../../common/predictive/predictive.component";
import { UsersService } from '../../../../injections/users.service';
import "rxjs/add/operator/debounceTime";

@Component({
  selector: 'select-office',
  templateUrl: '../../templates/partials/selectOffice-service.html'
})
export class SelectOfficeServiceComponent{

    @Input() names: Array<any>;
    @Input() offices;
    public user;
    public officeSelected = null;
    public idUser = null;
    @Output() predictUser = new EventEmitter();
    @Output() loadDataOffice = new EventEmitter();
    @ViewChildren(PredictiveComponent) predictives: QueryList<PredictiveComponent>;

    constructor(private serviceService: ServiceService, private usersService: UsersService){
    }

    public emptyPredictiveArray(type){
        this.predictives.forEach((item) => {
            if(type != item.type){
              item.items = [];
              item.inputValue = null;
              item.selected = 0;
            }else{
              if(item.inputValue != ''){
                this.setPredictive(item);
              }else{
                item.items = [];
                item.inputValue = null;
                item.selected = 0;
              }
            }
        });  
  }

  private setPredictive(predictive: PredictiveComponent) {
      switch (predictive.type){
        case 'phone':
        this.usersService.findUserByPhone(predictive.inputValue)
        .subscribe(result => {
          if(result instanceof Array){
              predictive.items = result;
            }else{
              predictive.items = [];
            }
        });
        break;
        case 'email':
        this.usersService.findUserByEmail(predictive.inputValue)
        .subscribe(result => {
          if(result instanceof Array){
              predictive.items = result;
            }else{
              predictive.items = [];
            }
        });
        break;
        case 'name':
        var encodedValue = encodeURI(predictive.inputValue)
        this.usersService.findUserByFullName(encodedValue)
        .subscribe(result => {
          if(result instanceof Array){
              predictive.items = result;
            }else{
              predictive.items = [];
            }
        });
        break;
        case 'surname':
        this.usersService.findUserBySurname(predictive.inputValue)
        .subscribe(result => {
          if(result instanceof Array){
              predictive.items = result;
            }else{
              predictive.items = [];
            }
        });
        break;
      }
  }

  public onChange(id) {
    this.officeSelected = id;
  }


  public itemSelected(data: any) {
    this.setComercialValue(data);
  }

  public predictOffice(term: string) {
    this.predictUser.emit(term);
  }

  public setComercialValue(value: any) {
    this.loadDataOffice.emit(value);
  }

  public loadOffice() {
    this.officeSelected = <string>this.officeSelected;
    this.loadDataOffice.emit({officeId: this.officeSelected, userId: this.idUser});
  }


}


// WEBPACK FOOTER //
// ./src/app/modules/services/components/dummy/selectOffice-service.component.ts